import { Injectable } from '@angular/core';
import { collection, Firestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class FirebaseReferencesService {
  constructor(private firestore: Firestore) {}

  public buildCollectionRef(userId: string) {
    return collection(this.firestore, `transactions-${userId}`);
  }
}
